import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { confirmToken } from "../apis/apis";
import { Snackbar, Alert, Typography } from "@mui/material";

function EmailVerification() {
    const { token } = useParams();
    const [status, setStatus] = useState("Verifying...");
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });
    const navigate = useNavigate();

    useEffect(() => {
        const verifyToken = async () => {
            if (!token) {
                setSnackbar({ open: true, message: "No token found.", severity: "error" });
                return;
            }

            try {
                const response = await confirmToken(token);
                if (!response.reason || response.reason.toLowerCase() !== "email verified") {
                    throw new Error("Verification failed.");
                }

                setSnackbar({ open: true, message: "Verification successful!", severity: "success" });
                navigate("/")
            } catch (error) {
                setSnackbar({ open: true, message: `Error: ${error.message}`, severity: "error" });
                setStatus("Verification failed.");
            }
        };
        verifyToken();
    }, [token]);

    return (
        <>
            <Typography variant="h6" align="center" color={status.includes("failed") ? "error" : "primary"}>
                {status}
            </Typography>
            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
            >
                <Alert onClose={() => setSnackbar({ ...snackbar, open: false })} severity={snackbar.severity}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </>
    );
}

export default EmailVerification;